import { render, staticRenderFns } from "./TransactionIcon.vue?vue&type=template&id=aa6d3f74"
import script from "./TransactionIcon.vue?vue&type=script&lang=js"
export * from "./TransactionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports